import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RadioComponent } from './radio.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslateModule } from '@ngx-translate/core'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'

@NgModule({
  declarations: [RadioComponent],
  imports: [CommonModule, FormsModule, TranslateModule, ContentEditableModule],
  exports: [RadioComponent],
})
export class RadioModule {}
